import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  Box
} from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { API, graphqlOperation } from 'aws-amplify';
import { createQuestionGroupTypes, updateQuestionGroupTypes, deleteQuestionGroupTypes } from '../graphql/mutations';
import { listQuestionGroupTypes } from '../graphql/queries';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.1)',
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '15px',
    backgroundColor: '#f9f9f9',
  },
  tableHeader: {
    backgroundColor: '#01b5e2',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#e5f7fb',
    },
  },
  tableCell: {
    padding: theme.spacing(1.5, 2),
    fontSize: '0.9rem',
  },
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    backgroundColor: 'white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const AddQuestionGroupTypeForm = () => {
  const [name, setName] = useState('');
  const [groupTypes, setGroupTypes] = useState([]);
  const [editingGroupTypeId, setEditingGroupTypeId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [deleteGroupId, setDeleteGroupId] = useState(null);

  const classes = useStyles();


  useEffect(() => {


    fetchGroupTypes();
  }, []);

  const fetchGroupTypes = async () => {
    const response = await API.graphql(graphqlOperation(listQuestionGroupTypes));
    setGroupTypes(response.data.listQuestionGroupTypes.items);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (editingGroupTypeId) {
      // Update existing group type
      await API.graphql(
        graphqlOperation(updateQuestionGroupTypes, {
          input: {
            id: editingGroupTypeId,
            name: name,
          },
        })
      );
    } else {
      // Create new group type
      await API.graphql(
        graphqlOperation(createQuestionGroupTypes, {
          input: {
            name: name,
          },
        })
      );
    }

    // Clear form fields
    setName('');

    setEditingGroupTypeId(null);
    fetchGroupTypes();
  };

  const handleEdit = (groupTypeId) => {
    const groupType = groupTypes.find((type) => type.id === groupTypeId);
    if (groupType) {
      setName(groupType.name);

      setEditingGroupTypeId(groupTypeId);
    }
  };

  const handleCancelEdit = () => {
    setName('');

    setEditingGroupTypeId(null);
  };

  const handleDelete = async () => {
    await API.graphql(
      graphqlOperation(deleteQuestionGroupTypes, {
        input: { id: deleteGroupId }
      })
    );
    setShowModal(false);
    fetchGroupTypes();
  };

  const openModal = (groupTypeId) => {
    setDeleteGroupId(groupTypeId);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Name"
          variant="outlined"
          value={name}
          onChange={(event) => setName(event.target.value)}
          fullWidth
          margin="normal"
        />
      
        <br />
        <br />
        <Button type="submit" variant="contained" color="primary">
          {editingGroupTypeId ? 'Update' : 'Submit'}
        </Button>
        {editingGroupTypeId && (
          <Button variant="outlined" color="secondary" onClick={handleCancelEdit} style={{ marginLeft: '16px' }}>
            Cancel
          </Button>
        )}
      </form>
      <TableContainer component={Paper} className={classes.tableContainer} style={{ marginTop: '32px' }}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeader}>
              <TableCell>Name</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groupTypes.map((groupType) => (
              <TableRow key={groupType.id} className={classes.tableRow}>
                <TableCell className={classes.tableCell}>{groupType.name}</TableCell>
                <TableCell className={classes.tableCell}>
                  <Button variant="outlined" color="primary" onClick={() => handleEdit(groupType.id)}>
                    Edit
                  </Button>
                  <Button variant="outlined" color="secondary" onClick={() => openModal(groupType.id)} style={{ marginLeft: '16px' }}>
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal
        open={showModal}
        onClose={closeModal}
      >
        <Box className={classes.modal}>
          <h2>Are you sure you want to delete this group type?</h2>
          <Button variant="contained" color="primary" onClick={handleDelete}>Yes</Button>
          <Button variant="outlined" color="secondary" onClick={closeModal} style={{ marginLeft: '16px' }}>No</Button>
        </Box>
      </Modal>
    </div>
  );
};

export default AddQuestionGroupTypeForm;
